import { useEffect, useRef } from 'react';

import { useAnalytics } from '@hooks/useAnalytics/useAnalytics';
import type { LeadCaptureReason } from '@t/serviceQualification.types';

interface LeadStartedQualification {
  receivedAddressId: string | null;
  leadCaptureReason: LeadCaptureReason | null;
}

export const useFireLeadStartedOnOpen = (
  open: boolean,
  sessionId: string | null,
  qualification: LeadStartedQualification
): void => {
  const { fire } = useAnalytics();
  const latestRef = useRef({ sessionId, qualification });
  latestRef.current = { sessionId, qualification };

  useEffect(() => {
    if (!open) return;
    const { sessionId: sid, qualification: qual } = latestRef.current;
    if (!sid) return;
    fire('trackLeadStarted', { sessionId: sid, qualification: qual });
  }, [open, fire]);
};
